<template>
<div class="page-content-wrapper">
  <div class="page-content role">
    <!-- BEGIN PAGE HEADER-->
    <div class="page-bar">
      <ul class="page-breadcrumb">
        <li>
          <i class="fa fa-home"></i>
          <a href="index.html">首页</a>
          <i class="fa fa-angle-right"></i>
        </li>
        <li>
          <a href="#">用户</a>
        </li>
      </ul>
    </div>
    <!-- END PAGE HEADER-->
    <div id="search-bar" class="lp-flex-box search-bar-item">
      <input type="text" name="name" placeholder="输入名称查询" class="form-control" v-model="biz.nickname">
      <button type="button" class="btn blue" @click="search">查询 <i class="fa fa-search"></i></button>
      <button type="button" class="btn green" @click="detail(0)">新增用户 <i class="icon-plus m-icon-white"></i></button>
    </div>
    <br>
    <table class="table table-striped table-hover table-bordered table-condensed">
      <thead>
        <tr>
          <th width="30%" class="text_overflow">账号</th>
          <th class="text_overflow">名称</th>
          <th width="15%" class="text_overflow">最后登入时间</th>
          <th width="8%" class="text_overflow">状态</th>
          <th width="10%">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in biz.items">
          <td style="vertical-align:middle" class="text_overflow">{{item.username}}</td>
          <td style="vertical-align:middle" class="text_overflow">{{item.nickname}}</td>
          <td style="vertical-align:middle" class="text_overflow">{{dtFormat(item.last_login)}}</td>
          <td style="vertical-align:middle" class="text_overflow">{{item.status}}</td>
          <td>
            <a href="javascript:void(0)" @click="detail(item.id)">详情</a>|
            <a href="javascript:void(0)" @click="remove(item.id)">删除</a>
          </td>
        </tr>
      </tbody>
    </table>
    <div id="pager-bar">
      <pager :page-index="pageIndex" :page-size="pageSize" :total-count="totalCount" :action="query" @page-change="onPageChange"></pager>
    </div>
  </div>
</div>
</template>

<script>
import http from '../../lib/utils/request.js'
import Pager from '../fragment/Pager.vue'
import BootstrapModal from '../fragment/BootstrapModal.vue'
import AccountEdit from './AccountEdit.vue'
import {mapState} from 'vuex'
import mixins from '../../mixins/index'
import common from '../../lib/methods/common.js'
import {MSG_ID, SER_RESP_CODE} from '../../lib/constant.js'
export default {
  name: 'role',
  mixins: mixins,
  data () {
    return {
      biz: {
        items: [],
        nickname: ''
      },
      pageIndex: 1,
      pageSize: 20,
      totalCount: 0
    }
  },
  components: {
    BootstrapModal,
    AccountEdit,
    Pager
  },
  created () {
    window.emitter.on(MSG_ID.MSG_ACCOUNT_SET_SUCCESS, (...args) => {
      this.query()
    })
  },
  mounted () {
    this.query()
  },
  methods: {
    onPageChange (pageIndex) {
      this.query()
    },
    search () {
      this.resetPager()
      this.query()
    },
    query () {
      // console.log(this.biz)
      let that = this
      let reqdata = {page_index: this.pager.pageIndex, page_size: this.pageSize, account: this.uid(), nickname: this.biz.nickname}
      http.invoke('auth.pageAccount', reqdata, function (data) {
        that.biz.items = data.content
        that.totalCount = data.total_count
      })
    },
    detail (id) {
      window.emitter.emit(MSG_ID.MSG_UI_SHOW_MODAL, AccountEdit, {title: '编辑账号', id: id})
    },
    remove (id) {
      window.emitter.emit(MSG_ID.MSG_UI_CONFIRM, '删除账号', (data) => {
        let reqdata = {action: 2, id: id}
        http.invoke('auth.setAccount', reqdata, (data) => {
          window.emitter.emit(MSG_ID.MSG_ACCOUNT_SET_SUCCESS)
        }, (state) => {
          if (state.code !== 2000000) {
            window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, SER_RESP_CODE[state.code])
            return
          }
          switch (state.result) {
            case 1:
              window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, '账号不能删除')
              break
            default:
              window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, '操作失败')
          }
        })
      })
    },
    ...common
  },
  computed: {
    ...mapState({
      pager: state => state.pager
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.role {
  background-color: #fff;
}
#pager-bar {
  text-align: center;
}
.search-bar-item {
  flex-grow: 1;
}

@media screen and (max-width: 767px) {
  .mh {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// Account.vue?df484522